import maybeWarnAboutDeleting from '../../../helpers/maybeWarnAboutDeleting';

import taskTemplateListItemOptionsUrl from './taskTemplateListItemOptions.html';

class TaskTemplateListItemOptionsCtrl {
  constructor(AlertService, Authentication, ConfirmService, TaskTemplatesService, $uibModal) {
    'ngInject';

    Object.assign(this, {
      AlertService,
      Authentication,
      ConfirmService,
      TaskTemplatesService,
      $uibModal,
    });
  }

  async deleteTemplate() {
    await this.maybeWarnAboutDeletingTaskInstance();
    await this.TaskTemplatesService.remove(this.template.id);
    this.AlertService.info('Template successfully deleted');
  }

  maybeWarnAboutDeletingTaskInstance() {
    return maybeWarnAboutDeleting(this.Authentication, this.$uibModal);
  }
}

export default {
  templateUrl: taskTemplateListItemOptionsUrl,
  controller: TaskTemplateListItemOptionsCtrl,
  controllerAs: 'ctrl',
  bindings: {
    template: '<',
  },
};
